import React from 'react';
import {  Line} from 'react-konva';

const Grid = ({gridSize,gridLinesHorizondal,gridLinesVertical,padding,gridLinesColor, enableDarkGridLine, opacity, GridClick, gridColor}) =>  {
    let GridValues = [];

    if(enableDarkGridLine) {
        let HlineIndexs = [], VlineIndexs = [];

        let darkGridLineColor = "#0d0d0d";
        
        // if (gridColor === "medium") {
        //     darkGridLineColor = "#d4d4d4";
        // }
        
        let gridHCenterLine = Math.trunc((gridLinesHorizondal.current / 2));
        for (let i = parseInt(gridHCenterLine / 5); i >= 0; i--) {
            if((HlineIndexs.indexOf(gridHCenterLine - i*5)) < 0 && (gridHCenterLine - i*5 > 0)) {
                HlineIndexs.push(gridHCenterLine - i*5)
                GridValues.push({
                    key:`grid-line-horizondal-Left-${gridHCenterLine - i*5}`,
                    points: [gridSize.originX,gridSize.originY+Math.round((gridHCenterLine - i*5) * padding) ,  gridSize.originX+gridSize.width, gridSize.originY+Math.round((gridHCenterLine - i*5) * padding) ],
                    stroke: darkGridLineColor,
                    strokeWidth:2
                })
            }
        }

        for (let i = 0; i <= parseInt(gridHCenterLine / 5); i++) {
            if((HlineIndexs.indexOf(gridHCenterLine + i*5) < 0) && (gridHCenterLine + i*5 > gridHCenterLine)) {
                HlineIndexs.push(gridHCenterLine + i*5)
                GridValues.push({
                    key:`grid-line-horizondal-Right-${gridHCenterLine + i*5}`,
                    points: [gridSize.originX,gridSize.originY+Math.round((gridHCenterLine + i*5) * padding) ,  gridSize.originX+gridSize.width, gridSize.originY+Math.round((gridHCenterLine + i*5) * padding) ],
                    stroke: darkGridLineColor,
                    strokeWidth:2,
                })
            }
        }

        let gridVCenterLine = Math.trunc((gridLinesVertical.current / 2));
        for (let i = parseInt(gridVCenterLine / 5); i >= 0; i--) {
            if((VlineIndexs.indexOf(gridVCenterLine - i*5)) < 0 && (gridVCenterLine - i*5 > 0)) {
                VlineIndexs.push(gridVCenterLine - i*5)
                GridValues.push({
                    key:`grid-line-vertical-Left-${gridVCenterLine - i*5}`,
                    points:[gridSize.originX+Math.round((gridVCenterLine - i*5) * padding) , gridSize.originY, gridSize.originX+Math.round((gridVCenterLine - i*5) * padding),  gridSize.originY+gridSize.height],
                    stroke: darkGridLineColor,
                    strokeWidth:2,
                })
            }
        }

        for (let i = 0; i <= parseInt(gridVCenterLine / 5); i++) {
            if((VlineIndexs.indexOf(gridVCenterLine + i*5) < 0) && (gridVCenterLine + i*5 > gridVCenterLine)) {
                VlineIndexs.push(gridVCenterLine + i*5)
                GridValues.push({
                    key:`grid-line-vertical-Right-${gridVCenterLine + i*5}`,
                    points:[gridSize.originX+Math.round((gridVCenterLine + i*5) * padding) , gridSize.originY, gridSize.originX+Math.round((gridVCenterLine + i*5) * padding),  gridSize.originY+gridSize.height],
                    stroke: darkGridLineColor,
                    strokeWidth:2,
                })
            }
        }
    }
    
    for (let i = 0; i <= gridLinesHorizondal.current; i++) {
        GridValues.push({
            key:`grid-line-horizondal-${i}`,
            points: [gridSize.originX,gridSize.originY+Math.round(i * padding) ,  gridSize.originX+gridSize.width, gridSize.originY+Math.round(i * padding) ],
            stroke:gridLinesColor,
            strokeWidth:0.9,
        })
    }

    for (let i = 0; i <= gridLinesVertical.current; i++) {
        GridValues.push({
            key:`grid-line-vertical-${i}`,
            points:[gridSize.originX+Math.round(i * padding) , gridSize.originY, gridSize.originX+Math.round(i * padding),  gridSize.originY+gridSize.height],
            stroke:gridLinesColor,
            strokeWidth:0.9,
        }) 
    }

    return (
        GridValues.map(grid => {
            let keyArr = grid.key.split("-");
            let keyIndex = 0;
            if (keyArr && keyArr.length) {
                keyIndex = parseInt(keyArr[keyArr.length - 1]);
            }
            if (
                (grid.key.includes("grid-line-horizondal") && (keyIndex === 0 || keyIndex === gridLinesHorizondal.current))
                ||
                (grid.key.includes("grid-line-vertical") && (keyIndex === 0 || keyIndex === gridLinesVertical.current))
            ) {
                return null;
            }
            return (
                <Line 
                    key={grid.key}
                    points={grid.points}
                    stroke={grid.stroke}
                    strokeWidth={grid.strokeWidth}
                    opacity={opacity}
                    onClick={GridClick}
                />
            )    
        })
    );
};

export default Grid;